module.exports = __webpack_public_path__ + "img/close_btn.39e3941.png";